import { asyncActionsCreator } from "@webiz/redux-common";
import {
  GET_NEXT_PAYOUT, 
  GET_PAYMENTS_TRANSACTION, 
  GET_PAYMENTS_TOTAL,
  GET_PAYMENTS_DATE,
  RESET_PAYMENTS_STATE
} from "./PaymentsTypes";

export const getNextPaymentsCount = asyncActionsCreator(GET_NEXT_PAYOUT);
export const getPaymentsTransaction = asyncActionsCreator(GET_PAYMENTS_TRANSACTION);
export const getPaymentsTotal = asyncActionsCreator(GET_PAYMENTS_TOTAL);
export const getPaymentsDate = asyncActionsCreator(GET_PAYMENTS_DATE);
export const resetPaymentsStateAction = asyncActionsCreator(RESET_PAYMENTS_STATE);
